import { render, staticRenderFns } from "./ServiceHealth.vue?vue&type=template&id=08200166&scoped=true"
import script from "./ServiceHealth.vue?vue&type=script&lang=js"
export * from "./ServiceHealth.vue?vue&type=script&lang=js"
import style0 from "./ServiceHealth.vue?vue&type=style&index=0&id=08200166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08200166",
  null
  
)

export default component.exports